export default "__VITE_ASSET__f206e6d1__"